import React from 'react';

import './style.scss';
import { Link } from "react-router-dom";
import Btn from "../../Btn";

export const TellEveryone = () => {
    return (
        <div className = 'wt wt-add-history'>
            <Link className = 'wt__container wt-add-history__container' to = '/add-history'>
                <h4 className = 'wt__title wt-add-history__title'>Розкажіть всім свою історію</h4>
                <div className = 'wt-add-history__btn'>
                    <Btn
                        full
                        theme = 'main'
                        title = 'Написати історію'
                    />
                </div>
            </Link>
        </div>
    );

};
